import React from 'react';

import get from 'lodash/get';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';

import { Dropdown } from '@src/components/ui/Dropdown';
import { useStatesQuery } from '@src/hooks/queries/states';
import {
    isStatesLoading,
    getStates,
} from '@src/selectors';


const StatesDropdown = ({ selectedState, statesData, onChange }) => {
    const statesQuery = useStatesQuery({ enabled: !statesData });

    const { isLoading, states } = React.useMemo(() => {
        let isLoading;
        let states;

        if (statesData) {
            isLoading = isStatesLoading(statesData);
            states = getStates(statesData).toJS();
        } else {
            isLoading = statesQuery.isLoading;
            states = get(statesQuery, ['data', 'states'], []);
        }

        states = states.map((state) => ({
            id: state.slug,
            title: state.name,
        }));

        return { isLoading, states };
    }, [statesData, statesQuery]);

    const handleDropdownChange = React.useCallback((value) => {
        if (value === Dropdown.ALL_OPTION) {
            value = null;
        }

        if (onChange) onChange(value);
    }, [onChange]);

    return (
        <Dropdown
            defaultSelection="State"
            title="State"
            list={states}
            isLoading={isLoading}
            selectedOption={selectedState}
            onChange={handleDropdownChange}
        />
    );
};

StatesDropdown.propTypes = {
    selectedState: PropTypes.string,
    statesData: ImmutablePropTypes.mapContains({
        loaded: PropTypes.string.isRequired,
        states: ImmutablePropTypes.listOf(ImmutablePropTypes.mapContains({
            id: PropTypes.number.isRequired,
            slug: PropTypes.string.isRequired,
            name: PropTypes.string,
        })),
    }),
    onChange: PropTypes.func,
};

export default StatesDropdown;
